module.exports = __webpack_public_path__ + "static/assets/09469790f10bcd5ed51fe8f85f8bdc1e.svg";